<template>
    <div class="main_section">
        <div class="centered_div">
            <SectionHeader class="header_section_header" title="Clasificador por Contrapartes"
                description="Para cada contraparte de tus obligaciones, puedes asignar las cuentas y las categorías correspondientes." />
            <div class="container_table">
                <table>
                    <tr>
                        <td class="ttitle">
                            <div class="tttitle">
                                Tipo de clasificacion
                            </div>
                        </td>
                        <td class="ttitle">
                            <div class="tttitle">
                                Documentos
                            </div>
                        </td>
                        <td class="ttitle">
                            <div class="tttitle">
                                Contraparte
                            </div>
                        </td>
                        <td class="ttitle">
                            <div class="tttitle">
                                Tipo contraparte
                            </div>
                        </td>
                        <td class="ttitle">
                            <div class="tttitle">
                                Total periodo
                            </div>
                        </td>
                        <td class="ttitle">
                            <div class="tttitle">
                                Clasificación Cuenta
                            </div>
                        </td>
                        <td class="ttitle" v-for="type in types" v-bind:key="type">
                            <div class="attribute_title">
                                {{ type }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="ttitle2">
                            <div class="tttitle subline">
                                <SortButton @click="changeOrderGeneric('classify_by_counterpart')"
                                    :globalSortColumn="sortColumn" :column="'classify_by_counterpart'"
                                    :sortDirection="sortDirection"></SortButton>
                            </div>
                        </td>
                        <td class="ttitle2">
                            <div class="tttitle subline">
                                <SortButton @click="changeOrderGeneric('tax_document_count')"
                                    :globalSortColumn="sortColumn" :column="'tax_document_count'"
                                    :sortDirection="sortDirection"></SortButton>
                            </div>
                        </td>
                        <td class="ttitle2">
                            <div class="tttitle subline">
                                <div class="header_container_subs">
                                    <div class="header_item_subs">
                                        Nombre empresa
                                        <SortButton @click="changeOrderGeneric('alias')" class="little_margin"
                                            :globalSortColumn="sortColumn" :column="'alias'"
                                            :sortDirection="sortDirection"></SortButton>
                                    </div>
                                    <div class="header_item_subs">
                                        Rut
                                        <SortButton @click="changeOrderGeneric('rut')" class="little_margin"
                                            :globalSortColumn="sortColumn" :column="'rut'"
                                            :sortDirection="sortDirection"></SortButton>
                                    </div>
                                </div>
                            </div>
                        </td>

                        <td class="ttitle2">
                            <div class="tttitle subline nobreak change_period_container">
                                <SortButton @click="changeOrderGeneric('counterpart_type')"
                                    :globalSortColumn="sortColumn" :column="'counterpart_type'"
                                    :sortDirection="sortDirection"></SortButton>
                                <SimpleButton class="nobreak order_button filter_button"
                                    @click="toggleCounterpartFilter('accounts')">
                                    <img :src="filter_icon" :class="['filter_icon', { 'filter_icon_all': filter_css == 'all' },
                                        { 'filter_icon_some': filter_css == 'some' },
                                        { 'filter_icon_few': filter_css == 'few' },
                                        { 'filter_icon_none': filter_css == 'none' }
                                    ]" /><span class="filters_symbol">
                                        {{ filters_symbol }}</span>
                                </SimpleButton>
                                <transition name="fade-slide">
                                    <ChangeCounterpartFilter v-show="show_counterpart_filter" :allCounterparts="filters"
                                        :counterpartsOn="filters_on" class="change_filter_widget"
                                        @confirm="handleConfirmFilter" @close="handleClose" ref="filterChooser" />
                                </transition>
                            </div>
                        </td>
                        <td class="ttitle2">
                            <div class="tttitle nobreak subline change_period_container">
                                <SortButton @click="changeOrderGeneric('total_3_months')" :globalSortColumn="sortColumn"
                                    :column="'total_3_months'" :sortDirection="sortDirection"></SortButton>
                                <SimpleButton class="nobreak order_button period_button" @click="togglePeriodChooser()"
                                    style="z-index: 1000;">
                                    {{ currentPeriodString }}
                                </SimpleButton>
                                <transition name="fade-slide">
                                    <ChangePeriodTimeframe v-show="show_period_chooser" :currentPeriod="currentPeriod"
                                        class="change_period_widget" @confirm="handleConfirmPeriod" @close="handleClose"
                                        ref="periodChooser" />
                                </transition>
                            </div>
                        </td>
                        <td class="ttitle2">
                            <div class="tttitle subline">
                                <SortButton @click="changeOrderGeneric('accounts')" :globalSortColumn="sortColumn"
                                    :column="'accounts'" :sortDirection="sortDirection"></SortButton>
                            </div>
                        </td>
                        <td class="ttitle2" v-for="type in types" v-bind:key="type">
                            <div class="attribute_title  subline">
                                <SortButton @click="changeOrderGeneric('attribute', type)"
                                    :globalSortColumn="sortColumn" :column="'attribute_' + type"
                                    :sortDirection="sortDirection" />
                            </div>
                        </td>
                    </tr>
                    <tr v-for="entry in entries" v-bind:key="entry.id" class="counterpart_row"
                        v-show="checkFiltered(entry)">
                        <td class="fila">
                            <div :class="['nobreak_classify_desc', { 'x_documento': !entry.classify_by_counterpart }]">
                                {{ entry.classify_by_counterpart ? 'Por Contraparte' : 'Por Documento'
                                }}</div>
                        </td>
                        <td class="fila">
                            <div class="count_button">
                                <SimpleButton v-if="entry.tax_document_count > 0"
                                    @click="irAClasificacionXDocumento(entry, entry.pay_or_charge, entry.alias, entry.rut)">
                                    {{ entry.tax_document_count }} docs <img :src="popup_icon" class="popup_icon" />
                                </SimpleButton>
                            </div>
                        </td>
                        <td class="fila">
                            <div class="c_alias">{{ entry.alias }}</div>
                            <div class="c_rut">{{ entry.rut }}</div>
                        </td>
                        <td class="fila">
                            <div :class="['counterpart_type', { 'charge': entry.pay_or_charge == 'C' }]">{{
                                entry.counterpart_type }}</div>
                        </td>
                        <td class="fila_amount">
                            <div class="amount_period'">{{ money(entry.total_3_months) }}</div>
                        </td>
                        <td class="fila class_container" @mouseover="hoverPreFetchClassification(entry)">
                            <div class="button_container">
                                <SimpleButton v-for="plan in entry.accounts" v-bind:key="plan['level_3']"
                                    @click="() => openAccountByCompanyModal('Cuentas de la compañía', entry, 'is-account')"
                                    :classiValue="plan['level_3']">
                                    <span
                                        :class="['attribute', { 'template_attribute': plan['pure_template'] == 'true' }]">
                                        {{ plan['level_3'] }}
                                    </span>
                                </SimpleButton>
                            </div>
                            <SimpleButton v-if="(!entry.accounts || !entry.accounts.length)" :clasificar="true"
                                @click="() => openAccountByCompanyModal('Cuentas de la compañía', entry, 'is-account')">
                                Clasificar
                            </SimpleButton>
                        </td>
                        <td class="fila class_container" v-for="type in types" v-bind:key="entry.ci_id + '_' + type">
                            <div v-if="entry['attributable']">
                                <div class="button_container" v-if="type in entry.attribute">
                                    <SimpleButton v-for="subtype in entry.attribute[type]" v-bind:key="subtype['name']"
                                        @click="() => openAccountByCompanyModal('Categorías de la compañía', entry, 'is-category', type)"
                                        :classiValue="subtype['name']">
                                        {{ subtype['name'] }}
                                    </SimpleButton>
                                </div>
                                <SimpleButton v-if="!(type in entry.attribute)" :clasificar="true"
                                    @click="() => openAccountByCompanyModal('Categorías de la compañía', entry, 'is-category', type)">
                                    Clasificar
                                </SimpleButton>
                            </div>
                            <div v-if="!entry['attributable']">
                                <SimpleButton @click="na_warning()" class="na_button"
                                    title="No se puede asignar esta categoria sin asignar una Cuenta de Venta o de Costo primero.">
                                    N / A</SimpleButton>
                            </div>
                        </td>
                    </tr>
                </table>
            </div> <!-- container_table -->
        </div> <!-- centered_div -->
    </div> <!-- main-section div -->

</template>

<script>
import { getCategories, getPaginatedCounterparts, get_prorates_x_company_involved } from "@/api/carteraAnalista";
import ClassifyAccountAttributes from "@/components/modals/ClassifyAccountAttributes";
import SectionHeader from "@/components/sectionHeader/SectionHeader";
import { parseToMoney } from "@/utils/currency";
import DashboardClassificatorXDocument from "@/views/DashboardClassificatorXDocument";
import { trackPromise } from "../api/trackablePromise";
import ChangeCounterpartFilter from "../components/modals/ChangeCounterpartFilter.vue";
import ChangePeriodTimeframe from "../components/modals/ChangePeriodTimeframe.vue";
import SimpleButton from "../components/modals/SimpleButton.vue";
import SortButton from "../components/modals/SortButton.vue";

import { notificate } from "../utils/message";

let count = 0;
const order = ['Ventas', 'Costos', 'Gastos', 'No Operacional', 'Activo'];

export default {
    name: "DashboardClassificator",
    components: {
        SectionHeader,
        SortButton,
        SimpleButton,
        ChangePeriodTimeframe,
        ChangeCounterpartFilter,
    },
    data() {
        return {
            filters: ['Cliente', 'Proveedor', 'Honorario', 'Trabajador', 'Internacional', 'Recibo', 'Finiquito'],
            filters_on: ['Cliente', 'Proveedor', 'Honorario', 'Trabajador', 'Internacional', 'Recibo', 'Finiquito'],
            show_counterpart_filter: false,
            publicPath: "http://" + window.location.hostname,
            show_period_chooser: false,
            types: [],
            entries: [],
            showXDocumento: false,
            switch1: false,
            sortColumn: 'order',
            sortDirection: 'asc',
            currentPeriod: 60,
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal"
            },
            prefetches: new Map(),
        };
    },
    props: {
        isVisible: Boolean,
    },
    mounted() {
        this.getAllCategoriesFirst();
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutsidePeriod);
        document.removeEventListener('click', this.handleClickOutsideFilter);
    },
    methods: {
        classi_key(ci_id, p_or_c) {
            return 'classi_' + ci_id + '_' + p_or_c;
        },
        hoverPreFetchClassification(entry) {
            const classi_key = this.classi_key(entry.counterpart_id, entry.pay_or_charge);
            if (!this.prefetches.has(classi_key)) {
                let total_pending = 0;
                let oldestPromise = null;
                for (const value of this.prefetches.values()) {
                    if (value.isPending()) {
                        total_pending++;
                    } else {
                        if (!oldestPromise || oldestPromise.getAge() > value.getAge()) {
                            oldestPromise = value;
                            // } else if () {
                        }
                    }
                }
                if (total_pending >= 2 || this.prefetches.size > 30) {
                    console.log('skipping promise!');
                    return;
                }
                // if (this.prefetches.size > 30) {

                // }

                this.prefetches.set(classi_key, trackPromise(
                    get_prorates_x_company_involved(entry.ci_id, null, entry.pay_or_charge))
                );
            }
        },
        checkFiltered(entry) {
            return this.filters_on.includes(entry.counterpart_type);
        },
        toggleCounterpartFilter() {
            this.show_counterpart_filter = !this.show_counterpart_filter;
            if (this.show_counterpart_filter) {
                setTimeout(() => document.addEventListener('click', this.handleClickOutsideFilter), 1);
            } else {
                document.removeEventListener('click', this.handleClickOutsideFilter);
            }
        },
        togglePeriodChooser() {
            this.show_period_chooser = !this.show_period_chooser;
            if (this.show_period_chooser) {
                setTimeout(() => document.addEventListener('click', this.handleClickOutsidePeriod), 1);
            } else {
                document.removeEventListener('click', this.handleClickOutsidePeriod);
            }
        },
        handleClickOutsidePeriod(event) {
            const periodChooser = this.$refs.periodChooser;
            if (periodChooser && !periodChooser.$el.contains(event.target)) {
                this.show_period_chooser = false;
                document.removeEventListener('click', this.handleClickOutsidePeriod);
            }
        },
        handleClickOutsideFilter(event) {
            const filterChooser = this.$refs.filterChooser;
            if (filterChooser && !filterChooser.$el.contains(event.target)) {
                this.show_counterpart_filter = false;
                document.removeEventListener('click', this.handleClickOutsideFilter);
            }
        },
        closeTimeFrameChooser() {
            this.show_period_chooser = false;
        },
        handleClose() {
            this.show_period_chooser = false;
            this.show_counterpart_filter = false;
            document.removeEventListener('click', this.handleClickOutsidePeriod);
            document.removeEventListener('click', this.handleClickOutsideFilter);
        },
        resetMsgs() {
            this.sortColumn = 'total_3_months';
            this.sortDirection = 'desc';
        },
        findLowestLevel1(list) {
            let min = list.length + 1;
            for (const elem of list) {
                const val = elem['level_1'];
                const io = order.indexOf(val);
                if (io >= 0 && io < min) {
                    min = io;
                }
                if (min == 0) {
                    break;
                }
            }
            return min;
        },
        sortData(column, subtype = null, reset_msg = true) {
            if (reset_msg) {
                this.resetMsgs();
            }
            let col_name = column;
            if (subtype != null) {
                col_name = 'attribute_' + subtype;
            }
            if (count == 0) {
                this.sortColumn = 'order';
                this.sortDirection = 'asc';
            } else if (count == 1) {
                this.sortColumn = col_name;
                this.sortDirection = 'asc';
            } else if (count == 2) {
                this.sortColumn = col_name;
                this.sortDirection = 'desc';
            }
        },
        changeColumn(column, subtype = null) {
            let column_name = column;
            if (subtype) {
                column_name = column + '_' + subtype;
            }
            if (this.sortColumn != column_name) {
                count = 0;
                this.sortColumn = column;
                if (subtype) {
                    this.sortColumn = column + '_' + subtype;
                }
            }
            count = (count + 1) % 3;
        },
        actualSort(column, subtype = null) {
            this.entries = this.entries.sort((a, b) => {
                let pos = this.sortColumn.indexOf('attribute_');
                let col_name = this.sortColumn;
                if (pos == 0) {
                    col_name = 'attribute';
                }
                const valA = a[col_name];
                const valB = b[col_name];
                if (col_name == 'accounts') {
                    const la = valA.length;
                    const lb = valB.length;
                    if (la == 0 || lb == 0) {
                        return this.sortDirection === 'asc' ? la - lb : lb - la;
                    }
                    const lowestA = this.findLowestLevel1(valA);
                    const lowestB = this.findLowestLevel1(valB);
                    if (lowestA == lowestB) {
                        const subOrderA = a['total_3_months'];
                        const subOrderB = b['total_3_months'];
                        return subOrderB - subOrderA;
                    }
                    return this.sortDirection === 'asc' ? lowestA - lowestB : lowestB - lowestA;
                } else if (col_name == 'attribute') {
                    const attA = a['attributable'];
                    const attB = b['attributable'];
                    if (!attA || !attB) {
                        return this.sortDirection === 'asc' ? attA - attB : attB - attA;
                    }
                    const la = subtype in valA ? valA[subtype].length : 0;
                    const lb = subtype in valB ? valB[subtype].length : 0;
                    if (la == 0 || lb == 0) {
                        return this.sortDirection === 'asc' ? la - lb : lb - la;
                    }
                    let totalA = '', totalB = '';
                    for (let index = 0; index < valA[subtype].length; index++) {
                        totalA += valA[subtype]['name'];
                    }
                    for (let index = 0; index < valB[subtype].length; index++) {
                        totalB += valB[subtype]['name'];
                    }
                    if (totalA == totalB) {
                        const subOrderA = a['total_3_months'];
                        const subOrderB = b['total_3_months'];
                        return subOrderB - subOrderA;
                    }
                    const total_diff = totalA.localeCompare(totalB);
                    return this.sortDirection === 'asc' ? total_diff : -total_diff;
                } else {
                    let compare = 0;
                    if ((typeof valA === 'boolean' && typeof valB === 'boolean') || (typeof valA === 'number' && typeof valB === 'number')) {
                        compare = valA - valB;
                    } else {
                        compare = valA.localeCompare(valB);
                    }
                    if (compare == 0) {
                        const subOrderA = a['total_3_months'];
                        const subOrderB = b['total_3_months'];
                        return subOrderB - subOrderA;
                    }
                    return this.sortDirection === 'asc' ? compare : -compare;
                }
            });
            for (let ii = 0; ii < this.entries.length; ii++) {
                this.entries[ii]['actual_order'] = ii;
            }
        },
        changeOrderGeneric(column, subtype = null) {
            this.changeColumn(column, subtype);
            this.sortData(column, subtype, false);
            this.actualSort(column, subtype);
        },
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        na_warning() {
            notificate('No se puede asignar esta categoria sin asignar una Cuenta de Venta o de Costo primero.');
        },
        getAllCategoriesFirst() {
            getCategories().then((response) => {
                const data = response.data;
                this.types = data['types'];
                getPaginatedCounterparts(this.currentPeriod, 0, 12).then((response) => {
                    const data = response.data;
                    this.entries = data['page_data'];
                    for (let ii = 0; ii < this.entries.length; ii++) {
                        this.entries[ii]['actual_order'] = ii;
                    }
                    this.changeColumn('total_3_months');
                    this.changeOrderGeneric('total_3_months');
                    getPaginatedCounterparts(this.currentPeriod, 12, 99999).then((response) => {
                        const data = response.data;
                        this.entries.push(...data['page_data']);
                        for (let ii = 0; ii < this.entries.length; ii++) {
                            this.entries[ii]['actual_order'] = ii;
                        }
                    });
                });
            });
        },
        getAllCategories(method_post = null) {
            getPaginatedCounterparts(this.currentPeriod, 0, 12).then((response) => {
                const data = response.data;
                this.entries = data['page_data'];
                getPaginatedCounterparts(this.currentPeriod, 12, 99999).then((response) => {
                    const data = response.data;
                    this.entries.push(...data['page_data']);
                });
                if (method_post) {
                    method_post();
                }
            });
        },
        handleConfirmFilter() {
            this.show_period_chooser = false;
            document.removeEventListener('click', this.handleClickOutsidePeriod);
        },
        handleConfirmPeriod(selectedPeriod) {
            this.currentPeriod = selectedPeriod;
            this.getAllCategories(() => {
                this.resetMsgs();
                this.sortData('total_3_months', null, false);
                this.actualSort('total_3_months');
            });
            this.show_period_chooser = false;
            document.removeEventListener('click', this.handleClickOutsidePeriod);
        },
        irAClasificacionXDocumento(entry, pay_or_charge, company_alias, company_rut) {
            this.$buefy.modal.open({
                ...this.modalDefaultUpdateSheet,
                component: DashboardClassificatorXDocument,
                width: "95%",
                props: {
                    parent_entry: entry,
                    types: this.types,
                    company_involved: entry['ci_id'],
                    document_type: pay_or_charge,
                    company_alias: company_alias,
                    company_rut: company_rut,
                },
                events: {
                    close: () => {
                    }
                },
            });

        },
        openAccountByCompanyModal(tittleModal, contraparte, type, categoryType = null) {
            const prefetched = this.prefetches.get(this.classi_key(contraparte.counterpart_id, contraparte.pay_or_charge));
            this.prefetches.clear();

            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ClassifyAccountAttributes,
                canCancel: ['escape', 'button', 'outside'],
                props: {
                    tittleModal: tittleModal,
                    contraparteId: contraparte.ci_id,
                    type,
                    categoryType,
                    document_type: contraparte.pay_or_charge,
                    current_period: this.currentPeriod,
                    prefetched: prefetched,
                },
                events: {
                    close: (reloadedData) => {
                        if (reloadedData) {
                            const data = reloadedData[0];
                            const actual_order = contraparte['actual_order'];
                            data['actual_order'] = actual_order;
                            this.entries.splice(actual_order, 1, data)
                        }
                    }
                },
            });
        }
    },
    computed: {
        filters_symbol: function () {
            if (this.filters.length == this.filters_on.length) {
                return " *";
            }
            return " " + this.filters_on.length;
        },
        filter_icon: function () { return `${this.publicPath}/filter_icon.png` },
        filter_css: function () {
            const onl = this.filters_on.length;
            if (this.filters.length == onl) {
                return "all"
            } else if (onl > 5) {
                return "some";
            } else if (onl > 0) {
                return "few";
            }
            return "none";
        },
        popup_icon: function () { return `${this.publicPath}/popup_icon.png` },
        ascending_icon: function () { return `${this.publicPath}/order_ascending.png` },
        descending_icon: function () { return `${this.publicPath}/order_descending.png` },
        neutral_icon: function () { return `${this.publicPath}/order_neutral.png` },
        currentPeriodString: function () {
            if (this.currentPeriod > 0) {
                return this.currentPeriod + " meses";
            }
            return "Todo";
        }

    },
    watch: {
    }
}
</script>

<style scoped>
.little_margin {
    margin-left: 5px;
}

.filters_symbol {
    margin-left: 0.15em;
}

.filter_icon {
    width: 16px;
}

.filter_icon_all {
    filter: brightness(0.2) sepia(100%) hue-rotate(135deg) saturate(5000%);
}

.filter_icon_some {
    filter: brightness(0.26) sepia(100%) hue-rotate(155deg) saturate(5000%);
}

.filter_icon_few {
    filter: brightness(0.22) sepia(100%) hue-rotate(129deg) saturate(5000%);
}

.filter_icon_none {
    filter: brightness(1.0) hue-rotate(0deg);
}

.amount_period {
    text-align: right !important;
}

.counterpart_type {
    margin-left: 0.7em;
}

.change_period_container {
    position: relative;
}

.change_period_widget {
    position: absolute;
    top: -200px;
    left: 10px;
    z-index: 1000;
    background-color: #fafafa;
    border: 2px outset #fff;
    padding: 10px;
    box-shadow: 5px 5px 7px 3px rgba(0, 0, 0, 0.43);
}

.change_filter_widget {
    position: absolute;
    top: -220px;
    left: -40px;
    z-index: 1000;
    background-color: #fafafa;
    border: 2px outset #fff;
    padding: 10px;
    box-shadow: 5px 5px 7px 3px rgba(0, 0, 0, 0.43);
}

.centered_div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.header_section_header {
    margin-top: 20px;
}

.ttitle {
    text-align: center;
    vertical-align: top;
    padding: 10px;
}

.header_container_subs {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}

.header_item_subs {
    font-size: 80%;
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.subbutton {
    margin-left: 5px;
}

.ttitle2 {
    text-align: center;
}

.subline {
    margin-bottom: 6px !important;
}

.tttitle {
    text-align: center;
    display: inline-block;
    width: min-content;
    margin: auto;
    font-weight: 900;
}

.attribute_title {
    text-transform: capitalize;
    font-weight: 900;
}

.attribute {
    font-style: italic;
}

.template_attribute {
    font-weight: normal;
}

.counterpart_row {
    border-top: 1px solid #111111;
    border-bottom: 1px solid #111111;
    margin-bottom: 10px;
}

.fila_amount {
    text-align: right;
    padding: 10px 0 10px 0;
    margin: 0 0.5em 0 0.5em;
}

.fila {
    text-align: center;
    padding: 10px 0 10px 0;
}

.charge {
    color: #ff0000;
}

.class_container {
    text-align: center;
    vertical-align: middle;
}

.button_container {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    max-width: 400px;
    gap: 2px 4px;
    margin: 0 15px 0 15px;
}

.c_alias {
    font-weight: 600;
}

.c_rut {
    font-size: 80%;
}

.container_table {
    padding: 0 3% 0 3%;
}

.nobreak_classify_desc {
    text-align: center;
    white-space: nowrap;
    font-size: 80%;
}

.nobreak {
    white-space: nowrap;
}

.switch_center {
    text-align: center;
    padding-left: 10%;
}

.popup_icon {
    width: 16px;
    margin-left: 0.3em;
    margin-top: 2px;
    margin-bottom: -2px
}

.count_button {
    text-align: center;
}

.x_documento {
    color: #dd0000;
    font-style: italic;
}

.na_button {
    color: #777;
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.header-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
}

.filter_button {
    vertical-align: top;
    margin-left: 6px;
}

.period_button {
    width: 70px !important;
    vertical-align: top;
    margin-left: 6px;
}

.order_button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
}

.fade-slide-enter-active, .fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter, .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
</style>
<style>
.center-always-modal .animation-content {
    display: flex;
    justify-content: center
}
</style>